import React, { useState, useEffect } from "react";
import { Formik, Field, Form, ErrorMessage } from "formik";
import { ConfigProvider, Select, Checkbox, Space } from "antd";
import { IoMdArrowDropdown } from "react-icons/io";
import * as Yup from "yup";
import { toast } from "react-toastify";
import { LiaSave } from "react-icons/lia";
import "../../App.css";
import { capitalizeFirstLetter } from "../Common/Captilization";
import { GET_PERMISSIONS } from "../../Store/Type";
import {
  GetPermissionById,
  //GetPermissionData,
  SubmitPermissionData,
  SubmitOPPermissionData,
} from "../../Api/Role&Responsibilites/ActivePermission";
import {
  GetUserRoles,
  GetPermissions,
} from "../../Api/Role&Responsibilites/ActiveRoles";
import { useDispatch } from "react-redux";
import "../../App.css";
import { useRef } from "react";
const Option=Select;

export default function CreatePermission({
  setIsPermissionModalOpen,
  permissionupdate,
  SetPermissionUpdate,
  SetPermissionData,
  permissionData,
  filter,
  setPermission,
  createState,
  setcreateState
}) {
  console.log(permissionData,"sdcvfaresdxf")
  const validationSchema = Yup.object().shape({
    role_type: Yup.string().required("Role Type is required"),
    crud_permissions: Yup.array().min(1, "CRUD permission is required"),
  module_permissions: Yup.array()
    .of(
      Yup.object({
         module_id: Yup.string().required("Module ID is required"),
        module_name: Yup.string().required("Module Name is required"),
      })
    )
    .min(1, "Accessible Modules are required"),

  submodule_permissions: Yup.array()
    .min(1, "Sub-Modules are required"), // add separate validation


      
  });

  const [selectedCrudPermissions, setSelectedCrudPermissions] = useState([]);
  const [selectedModulePermissions, setSelectedModulePermissions] = useState(
    []
  );
  const [selectedActivePermissions, setSelectedActivePermissions] = useState(
    []
  );

  const access = sessionStorage.getItem("accessId");
  const [roleNames, setRoleNames] = useState([]);
  const [moduleError, setModuleError] = useState();
  const [crudError, setCrudError] = useState();
  const [role_type_id, setRoleId] = useState("");
  const [viewMode, setViewMode] = useState("Product Owner");
  //const [viewMode, setViewMode] = useState("Operator");
  const [user, setUser] = useState("");
  // const [rolesData, setRoleData] = useState();
  const [showModulePermissions, setShowModulePermissions] = useState(true);
  // const [userlist, setUserlist] = useState({
  //   user: "",
  // });
  const [rolesPermisionData, setRolesPermissionData] = useState();
  const [selectedModule, setSelectedModule] = useState();
  console.log(rolesPermisionData, "selectedmodule");
  //const getroleName = useSelector((state) => state.crm.role_name_list);
  const dispatch = useDispatch();
  const type_id = sessionStorage.getItem("type_id");
 const wrapperRef = useRef(null)
  // let modulePermissionsData = [
  //   { module_id: 1, module_name: "Partner - (UM)" },
  //   { module_id: 2, module_name: "Client - (UM)" },
  //   { module_id: 3, module_name: "Employee - (UM)" },
  //   { module_id: 4, module_name: "Offers & Deals" },
  //   { module_id: 5, module_name: "Advertisement" },
  //   { module_id: 6, module_name: "Promotions" },
  // ];
  const mainModules = [
    { module_no: 1, module_title: "Dashboard" },
    { module_no: 2, module_title: "Razorpay" },
    { module_no: 3, module_title: "User Management" },
    { module_no: 4, module_title: "Request Management" },
    { module_no: 5, module_title: "Offers" },
    { module_no: 6, module_title: "Advertisements" },
    { module_no: 7, module_title: "Promotions" },
    { module_no: 8, module_title: "Roles" },
    { module_no: 9, module_title: "Subscription" },
    { module_no: 10, module_title: "BackUp" },
    { module_no: 11, module_title: "Settings" },
    { module_no: 12, module_title: "RecycleBin" }
  ];
  let modulePermissionsData = [
    { module_no: 1, module_id: 1, module_name: "Dash Table - (DB)" },
    { module_no: 1, module_id: 2, module_name: "Bookings - (DB)" },
    { module_no: 1, module_id: 3, module_name: "Cancellation - (DB)" },
    { module_no: 2, module_id: 4, module_name: "Payments - (RP)" },
    { module_no: 2, module_id: 5, module_name: "Settlements - (RP)" },
    { module_no: 2, module_id: 6, module_name: "Refunds - (RP)" },
    { module_no: 3, module_id: 7, module_name: "Operator - (UM)" },
    { module_no: 3, module_id: 8, module_name: "Partner - (UM)" },
    { module_no: 3, module_id: 9, module_name: "Client - (UM)" },
    { module_no: 3, module_id: 10, module_name: "Employee - (UM)" },
    { module_no: 3, module_id: 11, module_name: "Passengers - (UM)" },
    { module_no: 4, module_id: 12, module_name: "Operator - (RM)" },
    { module_no: 4, module_id: 13, module_name: "Partner - (RM)" },
    { module_no: 4, module_id: 14, module_name: "Ads - (RM)" },
    { module_no: 4, module_id: 15, module_name: "Offers - (RM)" },
    { module_no: 4, module_id: 16, module_name: "Promotions - (RM)" },
    { module_no: 5, module_id: 17, module_name: "Discount - (OFF)" },
    { module_no: 5, module_id: 18, module_name: "Redeem - (OFF)" },
    { module_no: 6, module_id: 19, module_name: "Website - (ADS)" },
    { module_no: 6, module_id: 20, module_name: "Mobile - (ADS)" },
    { module_no: 7, module_id: 21, module_name: "Promotions" },
    { module_no: 8, module_id: 22, module_name: "PO Employee - (RR)" },
    { module_no: 8, module_id: 23, module_name: "OP Employee - (RR)" },
    { module_no: 9, module_id: 24, module_name: "Subscription" },
    { module_no: 10, module_id: 25, module_name: "Blocked History - (BU)" },
    { module_no: 10, module_id: 26, module_name: "Abhibus History - (BU)" },
    { module_no: 11, module_id: 27, module_name: "Company Settings - (SET)" },
    { module_no: 11, module_id: 28, module_name: "User Settings - (SET)" },
    { module_no: 11, module_id: 29, module_name: "Configuration - (SET)" },
    { module_no: 11, module_id: 30, module_name: "Product Integrations - (SET)",    },
    { module_no: 11, module_id: 31, module_name: "Theme Settings - (SET)" },
    { module_no: 12, module_id: 32, module_name: "Recycle Bin" },
    {module_no:2, module_id:33, module_name:"Commission"},
    {module_no:2, module_id:34, module_name:"Dashboard"},
  ];
  // Apply the condition based on the type_id
  if (type_id === "OP101") {
    modulePermissionsData = modulePermissionsData.filter((module) =>
      ["Employee - (UM)", "Promotions"].includes(module.module_name)
    );
  } else if (type_id === "OPEMP101") {
    modulePermissionsData = modulePermissionsData.filter((module) =>
      ["Employee - (UM)", "Promotions"].includes(module.module_name)
    );
  } else if (type_id === "PROEMP101") {
    modulePermissionsData = modulePermissionsData.filter((module) =>
      [
        "Partner - (UM)",
        "Client - (UM)",
        "Employee - (UM)",
        "Discount - (OFF)",
        "Redeem - (OFF)",
        "Website - (ADS)",
        "Mobile - (ADS)",
        "Promotions",
      ].includes(module.module_name)
    );
  } else if (type_id !== "PRO101") {
    modulePermissionsData = [];
  }

  // const modulePermissionOptions = modulePermissionsData.map((module) => ({
  //   label: module.module_name,
  //   value: module.module_name,
  //   module_no: module.module_no,
  // }));

  const modulePermissionOptions = modulePermissionsData
  .filter((module) => {
    // If access is "1", exclude module_id 4, 5, 6
    if (access === "2") {
      return ![4, 5, 6].includes(module.module_id);
    }
    return true; // Include all for other access levels
  })
  .map((module) => ({
    label: module.module_name,
    value: module.module_name,
    module_no: module.module_no,
  }));


  const crudPermissionOptions = [
    { label: "View", value: "view" },
    { label: "Create", value: "create" },
    { label: "Update", value: "update" },
    { label: "Delete", value: "delete" },
  ];

  // const permissionIdMap = {
  //   "Partner - (UM)": 1,
  //   "Client - (UM)": 2,
  //   "Employee - (UM)": 3,
  //   "Offers & Deals": 4,
  //   Advertisement: 5,
  //   Promotions: 6,
  // };

  const permissionIdMap = {
    "Dash Table - (DB)": 1,
    "Bookings - (DB)": 2,
    "Cancellation - (DB)": 3,
    "Payments - (RP)": 4,
    "Settlements - (RP)": 5,
    "Refunds - (RP)": 6,
    "Operator - (UM)": 7,
    "Partner - (UM)": 8,
    "Client - (UM)": 9,
    "Employee - (UM)": 10,
    "Passengers - (UM)": 11,
    "Operator - (RM)": 12,
    "Partner - (RM)": 13,
    "Ads - (RM)": 14,
    "Offers - (RM)": 15,
    "Promotions - (RM)": 16,
    "Discount - (OFF)": 17,
    "Redeem - (OFF)": 18,
    "Website - (ADS)": 19,
    "Mobile - (ADS)": 20,
    "Promotions": 21,
    "PO Employee - (RR)": 22,
    "OP Employee - (RR)": 23,
    "Subscription": 24,
    "Blocked History - (BU)": 25,
    "Abhibus History - (BU)": 26,
    "Company Settings - (SET)": 27,
    "User Settings - (SET)": 28,
    "Configuration - (SET)": 29,
    "Product Integrations - (SET)": 30,
    "Theme Settings - (SET)": 31,
    "Recycle Bin":32,
    "Commission":33,
    "Dashboard":34,
  };

  const fetchRolesPermission = async (roleId) => {
    try {
      const data = await GetPermissions(roleId, dispatch);
       setRolesPermissionData(data?.description);
      SetPermissionUpdate(data?.crud_permission_id);
      console.log(data.crud_permission_id, "rolesPermission");
    } catch (error) {
      console.log(error, "Error fetching Roles permission data.");
    }
  };

  const handleSubmit = async (values) => {
    console.log(values, "permissionupdate");
    try {
      const modulePermissions = values.module_permissions.map((permission) => ({
        module_id: permissionIdMap[permission.module_name],
        module_name: permission.module_name,
      }));
     
      const activePermissions = values.active_module_permissions.map(
        (permission) => ({
          module_id: permissionIdMap[permission.module_name],
          module_name: permission.module_name,
        })
      );
      if (type_id === "PRO101" || type_id === "PROEMP101") {
        const data = await SubmitPermissionData(
          {
            ...values,
            module_permissions: modulePermissions,
            active_module_permissions: activePermissions,
            
          },
          permissionupdate,
          dispatch,
          filter,
          showModulePermissions,
          rolesPermisionData
        );
         
        toast.success("Permission Updated Successfully");
      } else {
        const data = await SubmitOPPermissionData(
          { ...values, module_permissions: modulePermissions },
          permissionupdate,
          dispatch,
          filter,
          role_type_id,
          user,
          rolesPermisionData
        );
        toast.success("Permission Updated Successfully");
      }
      setPermission(true);
      setIsPermissionModalOpen(false);
    } catch (error) {
      console.error("Error uploading data", error);
    }
  };

  const fetchGetPermission = async () => {
    try {
      const data = await GetPermissionById(
        permissionupdate,
        SetPermissionUpdate,
        SetPermissionData,
        role_type_id
      );
      console.log(data, "role data");
      setUser(data?.user);
      fetchRolesPermission(data?.role_id);
      SetPermissionData(data);
      if (data && data.crud_permissions && data.module_permissions) {
        SetPermissionData(data);
        setSelectedCrudPermissions(
          data.crud_permissions.map((permission) => ({
            label: permission,
            value: permission,
          }))
        );
        // setUserlist((prevState) => ({
        //   ...prevState,
        //   user: data.user,
        // }));
        const mappedModulePermissions = (data.module_permissions || []).map(
          (permission) => ({
            module_id: permissionIdMap[permission.module_name] || null,
            module_name: permission.module_name || "Unknown",
          })
        );

        const mappedActivePermissions = (
          data.active_module_permissions || []
        ).map((permission) => ({
          module_id: permissionIdMap[permission.module_name] || null,
          module_name: permission.module_name || "Unknown",
        }));

        console.log(mappedModulePermissions, "mappedModulePermissions");

        setSelectedModulePermissions(mappedModulePermissions);
        setSelectedActivePermissions(mappedActivePermissions);
        setRoleId(data?.role_id);
        if (filter !== "PO" && type_id === "PRO101") {
          setShowModulePermissions(false);
        } else {
          setShowModulePermissions(true);
        }
      } else {
        console.error(
          "Error: Data returned from GetPermissionById is invalid or missing properties"
        );
      }
    } catch (error) {
      console.error("Error fetching additional user data", error);
    }
  };

  const processedPermissions =
    rolesPermisionData?.crud_permissions?.map((item) => {
      try {
        const parsedItem = JSON.parse(item);
        return { label: parsedItem.label, value: parsedItem.value };
      } catch (error) {
        return {
          label: item.charAt(0).toUpperCase() + item.slice(1),
          value: item.toLowerCase(),
        };
      }
    }) || []; // Fallback to an empty array if crud_permissions is undefined

  const fetchRoleTypes = async (selectedUser) => {
    console.log(selectedUser, "selectedUser");
    try {
      const userToFetch =
        selectedUser === "Employee" ? "EMP101" : "OP101" || selectedUser;

      const response = await GetUserRoles(userToFetch, dispatch);
      setRoleNames(response);
      console.log(response, "response role");

      if (type_id === "PRO101" && selectedUser === "Operator") {
        setShowModulePermissions(false);
      } else {
        setShowModulePermissions(true);
      }

      if (type_id === "OP101") {
        setShowModulePermissions(true);
      }
    } catch (error) {
      console.error("Error fetching role names based on user", error);
    }
  };

  useEffect(() => {
    if (
      type_id === "PRO101" &&
      rolesPermisionData?.crud_permission_id != null
    ) {
      SetPermissionUpdate(rolesPermisionData?.crud_permission_id);
    }
    console.log(permissionupdate, "permissionData");
  }, [rolesPermisionData, SetPermissionUpdate, type_id]);

  useEffect(() => {
    const selectedUser =
      filter === "OP" && type_id === "PRO101"
        ? "Operator"
        : filter === "PO" && type_id === "PRO101"
        ? "Employee"
        : type_id === "OP101"
        ? "Operator"
        : "";
    fetchRoleTypes(selectedUser);
    setUser(selectedUser);

    sessionStorage.setItem("user", selectedUser);
  }, [filter, type_id]);

  useEffect(() => {
    if (permissionupdate != null) {
      fetchGetPermission();
    }
  }, [ SetPermissionData]);
  console.log(selectedModulePermissions, "showModulePermissions");

  const changeSubModulePickerStyle = () => {
    const observer = new MutationObserver(() => {
      const crossMark = document.querySelector(".anticon-close");
      if (crossMark) {
        crossMark.className = "text-black hover:text-red-500";
      }
    });
    // Observe changes in the body or parent container of the Select component
    observer.observe(document.body, { childList: true, subtree: true });
    // if(placeholder){
    //   placeholder.className = "font-semibold text-[#acb6c6] font-sans text-left"
    // }
  };
  useEffect(() => {
    changeSubModulePickerStyle();
  }, []);

  const modulePermission=selectedModulePermissions.map((item => item.module_name))
  console.log(selectedModulePermissions,"modulePermissionsssssssssssss")

  return (
    <Formik
      initialValues={{
        role_type: permissionData?.role_type || "",
        crud_permissions:
          showModulePermissions && type_id === "PRO101"
            ? permissionData?.crud_permissions || selectedCrudPermissions
            : showModulePermissions === false
            ? permissionData?.crud_permissions || selectedCrudPermissions
            : crudPermissionOptions,
        module_permissions: showModulePermissions
          ? selectedModulePermissions
          : showModulePermissions === "false"
          ? modulePermissionsData
          : modulePermissionsData,
  
  submodule_permissions: showModulePermissions
          ? selectedModulePermissions:[],
         // you MUST add this if you show an error for it


        active_permissions: permissionData?.active_permissions || false,
        active_module_permissions: showModulePermissions
          ? selectedActivePermissions || []
          : modulePermissionsData,
          
      }}
      onSubmit={(values, { setSubmitting }) => {
        // dispatch({
        //   type: GET_PERMISSIONS,
        //   payload: values,
        // });
        handleSubmit(values);
        // setSubmitting(false);
        fetchRoleTypes(values?.user);
      }}
      validationSchema={validationSchema}
      enableReinitialize
    >
      {({ handleSubmit, values, setFieldValue, handleChange,setFieldTouched }) => (
        <Form onSubmit={handleSubmit}>
          {/* <div className="flex justify-between mr-[3vw]">
            <div className="text-[1.35vw] text-[#1F4B7F] mt-[0.3vw] mb-[1vw] font-bold">
            { (type_id === "PRO101" && permissionData?.crud_permissions) || (type_id === "OP101" && permissionupdate) ? "UPDATE PERMISSION" : "CREATE NEW PERMISSION"}  
            </div>
            <button
              className="flex bg-[#1F4B7F] mt-[0.3vw] px-[0.6vw] gap-[0.5vw] rounded-[0.75vw] items-center justify-center"
              type="submit"
            >
              <span>
                <LiaSave color="white" size={"1.5vw"} />
              </span>
              <span className="text-white text-[1vw]">Save</span>
            </button>
          </div> */}

          <div className="tline flex justify-between mb-[1vw]">
            <div className="text-[1.35vw] text-[#1F4B7F] font-bold mt-[0.25vw]">
              {(type_id === "PRO101" && permissionData?.crud_permissions) ||
              (type_id === "OP101" && permissionupdate)
                ? "UPDATE PERMISSION"
                : "CREATE NEW PERMISSION"}
            </div>
            <div className="w-1/2 pl-[6vw] flex items-end justify-around mt-[0.16vw]">
              <button
                type="submit"
                className="bg-[#1f487c] h-[2.2vw] w-[6vw] ml-[4.5vw] text-white rounded-[0.75vw]"
              >
                <div className="flex justify-center">
                  <LiaSave size={"1.4vw"} />
                  <div className="pl-[0.5vw] text-[1vw]">Save</div>
                </div>
              </button>
            </div>
          </div>
          <div className="grid grid-cols-2 gap-[1vw] pt-[1vw]">
            {/* {viewMode !== "Operator" && (
              <div>
                <label
                  htmlFor="user"
                  className="text-[#1F4B7F] text-[1.1vw] font-semibold"
                >
                  User
                </label>

                {permissionupdate != null ? (
                  // <Field
                  //   as="select"
                  //   id="user"
                  //   name="user"
                  //   value={capitalizeFirstLetter(values.user)}
                  //   disabled={permissionupdate ? true : false}
                  //   onChange={(e) => {
                  //     handleChange(e);
                  //     const selectedUser = e.target.value;
                  //     setUser(e.target.value);
                  //     sessionStorage.setItem("user", selectedUser);
                  //     fetchRoleTypes(selectedUser); // Pass selectedUser to fetchRoleTypes
                  //   }}
                  //   className="cursor-not-allowed border-r-[0.3vw] mt-[0.5vw] border-l-[0.1vw] border-t-[0.1vw] border-b-[0.3vw] placeholder-blue border-[#1F487C]
                  //        text-[#1F487C] text-[1.2vw] h-[2.75vw] w-[100%] rounded-[0.9vw] outline-none px-[1vw]"
                  // >
                  //   
                  //   <option label=" Operator Employee" value="Operator">
                  //     Operator Employee
                  //   </option>
                  //   <option label="Product Owner Employee" value="Employee">
                  //     Product Owner Employee
                  //   </option>
                  // </Field>

                  <ConfigProvider
                    theme={{
                      components: {
                        Select: {
                          optionActiveBg: "#aebed1",
                          optionSelectedColor: "#FFF",
                          optionSelectedBg: "#aebed1",
                          optionHeight: "2",
                        },
                      },
                    }}
                  >
                    <Select
                      placeholder="Select User"
                      value={capitalizeFirstLetter(values.user) || ""}
                      disabled={permissionupdate ? true : false}
                      className="custom-select bg-white outline-none w-full mt-[0.5vw] h-[3vw] text-[1vw] border-[#1F4B7F] border-l-[0.1vw] border-t-[0.1vw] rounded-xl 
                  border-r-[0.2vw] border-b-[0.2vw] placeholder-[#1F487C]"
                      onChange={(value) => {
                        setFieldValue("user", value);
                        setFieldValue("role_type", "");
                        setUser(value);
                        sessionStorage.setItem("user", value);
                        fetchRoleTypes(value);
                      }}
                      suffixIcon={
                        <span style={{ fontSize: "1vw", color: "#1f487c" }}>
                          <IoMdArrowDropdown size="2vw" />
                        </span>
                      }
                      options={[
                        {
                          value: "",
                          label: (
                            <div className="text-[1vw] font-semibold px-[0.2vw] pb-[0.1vw] text-[#1F487C]">
                              Select User
                            </div>
                          ),
                          disabled: true,
                        },
                        {
                          value: "Operator",
                          label: (
                            <div className="text-[1vw] font-semibold px-[0.2vw] pb-[0.1vw] text-[#1F487C]">
                              Operator Employee
                            </div>
                          ),
                        },
                        {
                          value: "Employee",
                          label: (
                            <div className="text-[1vw] font-semibold px-[0.2vw] pb-[0.1vw] text-[#1F487C]">
                              Product Owner Employee
                            </div>
                          ),
                        },
                      ]}
                    />
                  </ConfigProvider>
                ) : (
                  <ConfigProvider
                    theme={{
                      components: {
                        Select: {
                          optionActiveBg: "#aebed1",
                          optionSelectedColor: "#FFF",
                          optionSelectedBg: "#aebed1",
                          optionHeight: "2",
                        },
                      },
                    }}
                  >
                    <Select
                      placeholder="Select User"
                      value={
                        filter === "OP" && type_id === "PRO101"
                          ? "Operator"
                          : filter === "PO" && type_id === "PRO101"
                          ? "Employee"
                          : type_id === "OP101"
                          ? "Operator"
                          : values.user 
                      }
                      disabled={type_id} 
                      className="custom-select bg-white outline-none w-full mt-[0.5vw] h-[3vw] text-[1vw] border-[#1F4B7F] border-l-[0.1vw] border-t-[0.1vw] rounded-xl 
             border-r-[0.2vw] border-b-[0.2vw] placeholder-[#1F487C]"
                      // onChange={(value) => {
                      //   setFieldValue("user", value); 
                      //   setFieldValue("role_type", ""); 
                      //   setUser(value); 
                      //   sessionStorage.setItem("user", value); 
                      //   fetchRoleTypes(value); 
                      // }}
                      suffixIcon={
                        <span style={{ fontSize: "1vw", color: "#1f487c" }}>
                          <IoMdArrowDropdown size="2vw" />
                        </span>
                      }
                      options={[
                        {
                          value: "",
                          label: (
                            <div className="text-[1vw] font-semibold px-[0.2vw] pb-[0.1vw] text-[#1F487C]">
                              Select User
                            </div>
                          ),
                          disabled: true,
                        },
                        {
                          value: "Operator",
                          label: (
                            <div className="text-[1vw] font-semibold px-[0.2vw] pb-[0.1vw] text-[#1F487C]">
                              Operator Employee
                            </div>
                          ),
                        },
                        {
                          value: "Employee",
                          label: (
                            <div className="text-[1vw] font-semibold px-[0.2vw] pb-[0.1vw] text-[#1F487C]">
                              Product Owner Employee
                            </div>
                          ),
                        },
                      ]}
                    />
                  </ConfigProvider>
                )}

                <ErrorMessage
                  name="user"
                  component="div"
                  className="text-red-500 text-[0.8vw]"
                />
              </div>
            )} */}
            <div>
              <label
                htmlFor="role_type"
                className="text-[#1F4B7F] text-[1.1vw] font-semibold"
              >
                Role Type
                <span className="text-[1vw] text-red-600 pl-[0.25vw]">*</span>
              </label>
              {((type_id === "OP101" || type_id === "OPEMP101") &&
                permissionupdate != null) ||
              ((type_id === "PRO101" || type_id === "PROEMP101") &&
                permissionData?.crud_permissions) ? (
                <Field
                  as="input"
                  id="role_type"
                  name="role_type"
                  type="text"
                  disabled={!!permissionupdate} // Explicitly convert to boolean
                  className="cursor-not-allowed border-r-[0.3vw] mt-[0.5vw] border-l-[0.1vw] border-t-[0.1vw] border-b-[0.3vw] placeholder-blue border-[#1F487C]
                text-[#1F487C] text-[1vw] h-[2.90vw] w-[100%] rounded-[0.5vw] outline-none px-[1vw]"
                />
              ) : (
                <ConfigProvider
                  theme={{
                    components: {
                      Select: {
                        optionActiveBg: "#aebed1",
                        optionSelectedColor: "#FFF",
                        optionSelectedBg: "#e5e5e5",
                        optionHeight: "2",
                      },
                      
                    },
                    
                  }}
                >
                  <Select
                    placeholder="Select Role"
                    className="custom-select bg-white outline-none w-full mt-[0.5vw] h-[3vw] text-[1vw] border-[#1F4B7F] border-l-[0.1vw] border-t-[0.1vw] rounded-[0.5vw]
                    border-r-[0.2vw] border-b-[0.2vw] text-[#1F487C] "
                    
                    dropdownStyle={{
          transition:'none',
          position: 'absolute',
          marginTop: '2vw',
          width: '25.5%',
          zIndex: 1000,
          
          
        }}
                    value={values.role_type}
                    onChange={(value) => {
                      setFieldValue("role_type", value);
                      const selectedRole = roleNames?.find(
                        (role) => role.role_type === value
                      );
                      fetchRolesPermission(selectedRole?.role_id);
                      sessionStorage.setItem("role_type", value);
                    }}
                    suffixIcon={
                      <span style={{ fontSize: "1vw", color: "#1f487c" }}>
                        <IoMdArrowDropdown size="2vw" />
                      </span>
                    }
                    options={[
                      {
                        value: "",
                        label: (
                          <div className="text-[1vw]  px-[0.2vw] pb-[0.1vw]  text-[#1F487C]">
                            Select Role
                          </div>
                        ),
                        disabled: true,
                      },
                      ...(Array.isArray(roleNames) ? roleNames : []).map(
                        (roleName) => ({
                          value: roleName.role_type,
                          label: (
                            <div className="text-[1vw] font-semibold px-[0.2vw] pb-[0.1vw] text-[#1F487C]">
                              {capitalizeFirstLetter(roleName.role_type)}
                            </div>
                          ),
                        })
                      ),
                    ]}
                  />
                </ConfigProvider>
              )}

              <ErrorMessage
                name="role_type"
                component="div"
                className="text-red-500 text-[0.8vw] ml-[0.3vw] mt-[0.2vw]"
              />
            </div>
            <div>
              <label className="text-[#1F4B7F] text-[1.1vw] font-semibold">
                Description
              </label>
              <Field
                as="textarea"
                placeholder="Enter Description"
                style={{ resize: "none", lineHeight: "2.2vw" }}
                disabled
                value={rolesPermisionData}
                rows="3"
                cols="50"
                className="cursor-not-allowed border-r-[0.2vw] mt-[0.5vw] border-l-[0.1vw] border-t-[0.1vw] border-b-[0.2vw] placeholder-blue border-[#1F487C]
                   text-[#1F487C] text-[1vw] h-[3vw] w-[100%] rounded-[0.5vw] outline-none px-[1vw] py-[0.3vw] placeholder:font-medium placeholder:text-[#1F487C]"
              />
            </div>
          </div>
          {showModulePermissions !== false && filter !== "OP" && (
            <div className="mt-[1.75vw]">
              {/* <label
                htmlFor="module_permissions"
                className="text-[#1F4B7F] text-[1.1vw] font-semibold"
              >
                Module Permission
                <span className="text-[1vw] text-red-600 pl-[0.25vw]">*</span>
              </label> */}
              <div className="grid grid-cols-2 gap-[1vw]">
                <div>
                  <label
                    htmlFor="module_permissions"
                    className="text-[#1F4B7F] text-[1.1vw] font-semibold ml-[0.1vw]"
                  >
                    Accessible Modules
                    <span className="text-[1vw] text-red-600 pl-[0.25vw]">
                      *
                    </span>
                  </label>
                  <ConfigProvider
                    theme={{
                      components: {
                        Select: {
                          optionActiveBg: "#aebed1",
                          optionSelectedColor: "#FFF",
                          optionSelectedBg: "#e5e5e5",
                          optionHeight: "2",
                        },
                      },
                    }}
                  >
                    <Select
                      placeholder="Select Module"
                      className="col-span-1 custom-select bg-white outline-none w-full mt-[0.5vw] h-[3vw] text-[1vw] border-[#1F4B7F] border-l-[0.1vw] border-t-[0.1vw] rounded-[0.5vw]
                    border-r-[0.2vw] border-b-[0.2vw] placeholder-[#1F487C] ml-[0.1vw]"
                      // value={values.role_type}
                     onChange={(value) => {
setSelectedModule((prev) => {
                          return value;
                        });

 const selectedModuleObj = mainModules.find(
    (m) => m.module_no === value
  );

  if (selectedModuleObj) {
    setFieldValue("module_permissions", [
      {
        module_id: selectedModuleObj.module_no,
        module_name: selectedModuleObj.module_title,
      },
    ]);
  }

  setFieldTouched("module_permissions", false);
}} 


                      suffixIcon={
                        <span style={{ fontSize: "1vw", color: "#1f487c" }}>
                          <IoMdArrowDropdown size="2vw" />
                        </span>
                      }
                      options={[
                        {
                          value: "",
                          label: (
                            <div className="text-[1vw] font-semibold px-[0.2vw] pb-[0.1vw]  text-[#9ba6bbe3]">
                              Select Module
                            </div>
                          ),
                          disabled: true,
                        },
                        ...(Array.isArray(mainModules) ? mainModules : [])
                          
.filter((module) => {
    // Show only "Backup" if access_id is "1"
    if (access === "1") {
      return true;
    }
    // Otherwise, exclude "BackUp"
    return module.module_title !== "BackUp";
  }).map(

                          (module) => ({
                            value: module.module_no,
                            label: (
                              <div className="text-[1vw] font-semibold px-[0.2vw] pb-[0.1vw] text-[#1F487C]">
                                {capitalizeFirstLetter(module.module_title)}
                              </div>
                            ),
                          })
                        ),
                      ]}
                    />
                  </ConfigProvider>
                  <ErrorMessage
                name="module_permissions"
                component="div"
                className="text-red-500 text-[0.8vw] ml-[0.3vw] mt-[0.5vw]"
              />
                </div>

                <div className="relative" ref={wrapperRef}>
                  <label
                    htmlFor="submodule_permissions"
                    className="text-[#1F4B7F] text-[1.1vw] font-semibold flex items-center"
                  >
                    Sub-Modules
                    <span className="text-[1vw] text-red-600 pl-[0.25vw]">
                      *
                    </span>
                    <span className="text-[0.75vw] ml-[0.25vw]">
                      (select a module to view options here)
                    </span>
                  </label>
                  <Space style={{ width: "100%" }} direction="vertical">
                    <Select
                      mode="multiple"
                      
        allowClear
        placeholder="Click to select"
        // style={{ width: '100%' }}
        getPopupContainer={() => wrapperRef.current}
        popupMatchSelectWidth={false}
        dropdownAlign={{ overflow: { adjustY: false } }}
        dropdownStyle={{
          transition:'none',
          position: 'absolute',
          top: '57%',
          marginTop: '2vw',
          width: '22%',
          zIndex: 1000,
          
          
        }}
                      className="col-span-1 custom-select bg-white outline-none w-full mt-[0.5vw] h-[3vw]   text-[1vw] border-[#1F4B7F] border-l-[0.1vw] border-t-[0.1vw] rounded-[0.5vw]
                    border-r-[0.2vw] border-b-[0.2vw] pt-[0.3vw]  overflow-y-scroll "
                      // value={selectedValues ? selectedModulePermissions.map((per)=>per.module_name) : selectedValues.map((per)=>per.module_name)}
                    //  value={values.submodule_permissions}   // ✅ Correct binding

 value={values.submodule_permissions.map(
  (per) => per.module_name)}
// ):values.module_permissions.map(
//   (per) => per.module_name
// )}
onChange={(value) => {
  const updatedValues = [];

  value.forEach((val) => {
    const exists = updatedValues.some(
      (item) => item.module_name === val
    );

    if (!exists) {
      updatedValues.push({
        module_id: permissionIdMap[val],
        module_name: val,
      });
    }
  });

  setFieldValue("submodule_permissions", updatedValues);
  setFieldValue("module_permissions", [...updatedValues]);

  console.log(values.submodule_permissions,"submodule_permissions")
}}



 options={modulePermissionOptions?.filter(
                        (option) => option.module_no === selectedModule
                      )}
                    />
                    <ErrorMessage
  name="submodule_permissions"
  component="div"
  className="text-red-500 text-[0.8vw] -mt-[0.5vw] ml-[0.3vw]"
/>
                  </Space>
                  
                
                </div>
                
                {/* {selectedModule && (
                  <Field name="module_permissions">
                    {({ field, form }) => {
                      // Ensure field.value is always an array
                      const selectedValues = Array.isArray(field.value)
                        ? field.value
                        : [];

                      return (
                        <div className="ml-[2.5vw] pt-[0.5vw] gap-3 h-[7.5vw] col-span-1">
                          {modulePermissionOptions
                            ?.filter((opt) => opt.module_no === selectedModule)
                            .map((option) => (
                              <div
                                key={option.value}
                                className="flex items-center"
                              >
                                <input
                                  type="checkbox"
                                  id={option.value}
                                  name="module_permissions"
                                  value={option?.value}
                                  checked={selectedValues.some(
                                    (item) => item.module_name === option.value
                                  )}
                                  onChange={(e) => {
                                    // Make sure selectedValues is treated as an array
                                    const updatedValues = [...selectedValues];
                                    if (e.target.checked) {
                                      updatedValues.push({
                                        module_id:
                                          permissionIdMap[option.value],
                                        module_name: option.value,
                                      });
                                    } else {
                                      const index = updatedValues.findIndex(
                                        (item) =>
                                          item.module_name === option.value
                                      );
                                      if (index > -1)
                                        updatedValues.splice(index, 1);
                                    }

                                    form.setFieldValue(
                                      "module_permissions",
                                      updatedValues
                                    );
                                    console.log(
                                      selectedValues,
                                      updatedValues,
                                      "updatedvalues"
                                    );
                                  }}
                                  className="checkbox-custom cursor-pointer"
                                />
                                <label
                                  htmlFor={option.value}
                                  className="text-[1vw] cursor-pointer text-[#1F4B7F] pl-[0.5vw]"
                                >
                                  {option.label}
                                </label>
                              </div>
                            ))}
                        </div>
                      );
                    }}
                  </Field>
                )} */}
              </div>
            </div>
          )}

          {viewMode !== "Operator" && (
            <div className=" pt-[1vw]">
              <label
                htmlFor="crud_permission"
                className="text-[#1F4B7F] text-[1.1vw] font-semibold ml-[0.1vw]"
              >
                Permission
                <span className="text-[1vw] text-red-600 pl-[0.25vw]">*</span>
              </label>
              {type_id === "PRO101" ? (
                <Field name="crud_permissions">
                  {({ field, form }) => {
                    console.log("Field value:", field.value); // Debug to ensure field value is populated
                    console.log(
                      "Permission data:",
                      permissionData?.crud_permissions
                    ); // Debug to confirm data
                    return (
                      <div className="rmsc mt-[0.5vw] ml-[0.7vw]">
                        <div className="grid grid-cols-4 gap-[0.5vw] ">
                          {crudPermissionOptions.map((option) => (
                            <div
                              key={option.value}
                              className="flex items-center"
                            >
                              <input
                                type="checkbox"
                                id={option.value}
                                name="crud_permissions"
                                value={option.value}
                                disabled={type_id === "OP101"}
                                className="checkbox-custom mr-[0.5vw] cursor-pointer"
                                checked={field.value?.includes(option.value)} // Check if field.value contains the option
                                onChange={(e) => {
                                  const selectedValues = field.value
                                    ? [...field.value]
                                    : [];
                                  if (e.target.checked) {
                                    selectedValues.push(option.value);
                                  } else {
                                    const index = selectedValues.indexOf(
                                      option.value
                                    );
                                    if (index > -1) {
                                      selectedValues.splice(index, 1);
                                    }
                                  }
                                  form.setFieldValue(
                                    "crud_permissions",
                                    selectedValues
                                  );
                                }}
                              />
                              <label
                                htmlFor={option.value}
                                className="text-[1vw] cursor-pointer text-[#1F4B7F]"
                              >
                                {option.label}
                              </label>
                            </div>
                          ))}
                        </div>
                      </div>
                    );
                  }}
                </Field>
              ) : (
                <>
                  <div className="text-[1.1vw] font-medium px-[0.2vw] pb-[0.1vw] text-[#1F487C] relative">
                    {rolesPermisionData?.crud_permissions?.length > 0 ? (
                      <div className="flex flex-wrap gap-[1vw]">
                        {processedPermissions.map((permission, index) => (
                          <span key={index}>
                            {index + 1}. {permission.label}
                          </span>
                        ))}
                      </div>
                    ) : (
                      <div className="text-[1vw] text-[#FF0000] flex text-center justify-center font-medium">
                        No permissions.
                      </div>
                    )}
                  </div>
                </>
              )}
              <ErrorMessage
                name="crud_permissions"
                component="div"
                className="text-red-500 text-[0.8vw] ml-[0.3vw] mt-[0.25vw]"
              />
            </div>
          )}

          {/* Render Active Permission */}
          {showModulePermissions !== false &&
            filter !== "OP" &&
            type_id === "PRO101" && (
              <div className="flex flex-row mt-[2vw]">
                <label className="text-[#1F4B7F] text-[1.1vw] font-semibold ml-[0.15vw]">
                  Active Permission :
                </label>
                <div className="pl-[2vw]">
                  <label>
                    <Field
                      type="radio"
                      name="active_permissions"
                      value="true"
                      checked={values.active_permissions === true} // Check Boolean value
                      onChange={(e) =>
                      {
                        setFieldValue(
                          "active_permissions",
                          e.target.value === "true"
                        )
                       
                      }
                      }
                      className="w-[1vw] h-[1vw] accent-[#1F4B7F]"
                    />
                    <span className="text-[#1F4B7F] text-[1.1vw] cursor-pointer font-medium pl-[0.5vw]">
                      Yes
                    </span>
                  </label>
                  <label className="pl-[2vw]">
                    <Field
                      type="radio"
                      name="active_permissions"
                      value="false"
                      checked={values.active_permissions === false} // Check Boolean value
                      onChange={(e) =>
                      {
                        setFieldValue(
                          "active_permissions",
                          e.target.value === "true"
                        )
                        
                      }
                        
                      }
                      className="w-[1vw] h-[1vw] accent-[#1F4B7F]"
                    />
                    <span className="text-[#1F4B7F] text-[1.1vw] cursor-pointer font-medium pl-[0.5vw]">
                      No
                    </span>
                  </label>
                </div>
              </div>
            )}

          <Field name="active_permissions">
            {({ field }) =>
              field.value === true &&
              showModulePermissions !== false &&
              filter !== "OP" && (
                <div className="mt-[1.75vw]">
                  <label
                    htmlFor="active_module_permissions"
                    className="text-[#1F4B7F] text-[1.1vw] font-semibold"
                  >
                    Active Module Permissions
                  </label>
                  <Field name="active_module_permissions">
                    {({ field: activeField, form }) => (
                      <div className="grid grid-cols-4 ml-[0.5vw] pt-[0.5vw] h-[3vw] gap-3 overflow-y-scroll">
                        {form.values.submodule_permissions.map((permission) => (
                          <div
                            key={permission.module_name}
                            className="flex items-center"
                          >
                            <input
                              type="checkbox"
                              id={`active_${permission.module_name}`}
                              name="active_module_permissions"
                              value={permission.module_name}
                              
 
checked={
    selectedModulePermissions.some(
      (item) => item.module_name === permission.module_name
    )
      ? true
      : activeField.value.some(
          (item) => item.module_name === permission.module_name
        )
  }


                              onChange={(e) => {
                                const selectedValues = [...activeField.value];
                                if (e.target.checked) {
                                  selectedValues.push({
                                    module_id: permission.module_id,
                                    module_name: permission.module_name,
                                  });
                                } else {
                                  const index = selectedValues.findIndex(
                                    (item) =>
                                      item.module_name ===
                                      permission.module_name
                                  );
                                  if (index > -1)
                                    selectedValues.splice(index, 1);
                                }
                                form.setFieldValue(
                                  "active_module_permissions",
                                  selectedValues
                                );
                              }}
                              className="checkbox-custom cursor-pointer"
                            />
                            <label
                              htmlFor={`active_${permission.module_name}`}
                              className="text-[1vw] text-[#1F4B7F] pl-[0.5vw]"
                            >
                              {permission.module_name}
                            </label>
                          </div>
                        ))}
                      </div>
                    )}
                  </Field>
                  <ErrorMessage
                    name="active_module_permissions"
                    component="div"
                    className="text-red-500 text-[0.8vw] "
                  />
                </div>
              )
            }
          </Field>
        </Form>
      )}
    </Formik>
  );
}
